import { CommentDetail } from '@/types/api'

interface Props {
    comment: CommentDetail
    onReply?: () => void
}

export const CommentItem = ({ comment, onReply }: Props): JSX.Element => {
    // 將評分轉換為數字，參考 ReviewsCenter.tsx 的處理方式
    const rating = parseFloat(comment.rating) || 0

    return (
        <div className="flex items-stretch relative w-full md:w-[883px] bg-white rounded-[11.72px] overflow-hidden min-h-[135px]">
            <div className="flex flex-col flex-1 min-w-0 items-start relative border-r [border-right-style:solid] border-[#929084]">
                <div className="relative self-stretch w-full h-[65px] min-h-[65px]">
                    {/* 用戶頭像 */}
                    <div className="absolute top-[calc(50.00%_-_21px)] left-[22px] w-11 h-11 flex items-center justify-center">
                        <div className="mt-[0.6px] h-[29.3px] ml-[0.6px] w-[29.3px] bg-[#d9d9d9] rounded-[14.65px]" />
                    </div>

                    {/* 用戶名稱 */}
                    <div className="absolute top-[calc(50.00%_-_21px)] left-[73px] right-[22px] flex items-center">
                        <div className="flex items-center mt-[-0.5px] ml-[6.4px] max-w-full [font-family:'Noto_Sans_TC',Helvetica] font-bold text-[#1a1a1a] text-[14px] tracking-[1.00px] leading-[normal] truncate">
                            {comment.username}
                        </div>
                    </div>

                    {/* 星級評分和日期 */}
                    <div className="absolute top-[50.00%] left-[73px] right-[22px] flex items-center gap-2 flex-wrap">
                        {/* 星級 */}
                        <div className="flex items-center gap-1 flex-shrink-0">
                            {[1, 2, 3, 4, 5].map((star) => (
                                <img
                                    key={star}
                                    className="w-[11px] h-[11px]"
                                    alt="Star"
                                    src={star <= rating ? "/img/star-3-8.svg" : "/img/star-4-8.svg"}
                                />
                            ))}
                        </div>

                        {/* 日期時間 */}
                        <div className="flex items-center justify-center flex-shrink-0 [font-family:'Noto_Sans_TC',Helvetica] font-bold text-[#999898] text-[8px] tracking-[0] leading-[normal] whitespace-nowrap">
                            {comment.relative_date}
                        </div>
                    </div>
                </div>

                {/* 評論內容 - 動態高度 */}
                <div className="flex items-start justify-start gap-2.5 px-[22px] py-[15px] relative self-stretch w-full">
                    <div className="relative w-full [font-family:'Noto_Sans_TC',Helvetica] font-bold text-black text-sm tracking-[1.40px] leading-[normal] text-left break-words">
                        {comment.caption}
                    </div>
                </div>
            </div>

            {/* 回覆按鈕 - 垂直置中 */}
            <div className="flex items-center justify-center px-0 relative w-[180px] min-h-[135px]">
                <button
                    onClick={onReply}
                    className="relative w-[93px] h-[37px] bg-[#aeceb7] rounded-[5px] overflow-hidden hover:bg-[#9dbd9f] transition-colors cursor-pointer"
                >
                    <div className="absolute top-2.5 left-1/2 -translate-x-1/2 h-[17px] flex items-center justify-center [font-family:'Noto_Sans_TC',Helvetica] font-bold text-black text-sm tracking-[1.40px] leading-[normal] whitespace-nowrap">
                        回覆評論
                    </div>
                </button>
            </div>
        </div>
    )
}



